export class Company {
    id: number = 0;
    name: string = "";
}